const INTERNAL_WEBCHAT_HTTP_FALLBACK_KEY = 'runai:internal-webchat:http-fallback';

const INTERNAL_WEBCHAT_HTTP_FALLBACK_HOSTS = new Set([
  'i.run.ceo',
  'app.run.ceo',
  'localhost',
  '127.0.0.1',
]);

const INTERNAL_WEBCHAT_HTTP_FALLBACK_PATHS = new Set([
  '/',
  '/index.html',
]);

type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function getSessionStorage(storage?: StorageLike): StorageLike | undefined {
  return storage || (typeof window !== 'undefined' ? window.sessionStorage : undefined);
}

export function shouldUseInternalWebchatHttpFallback(storage?: StorageLike): boolean {
  return getSessionStorage(storage)?.getItem(INTERNAL_WEBCHAT_HTTP_FALLBACK_KEY) === '1';
}

export function markInternalWebchatHttpFallback(storage?: StorageLike): void {
  getSessionStorage(storage)?.setItem(INTERNAL_WEBCHAT_HTTP_FALLBACK_KEY, '1');
}

export function clearInternalWebchatHttpFallback(storage?: StorageLike): void {
  getSessionStorage(storage)?.removeItem(INTERNAL_WEBCHAT_HTTP_FALLBACK_KEY);
}

export function isInternalWebchatHttpFallbackEligible(
  pathname = window.location.pathname,
  hostname = window.location.hostname,
): boolean {
  const normalizedHost = hostname.trim().toLowerCase();
  const normalizedPath = pathname || '/';

  return INTERNAL_WEBCHAT_HTTP_FALLBACK_HOSTS.has(normalizedHost)
    && INTERNAL_WEBCHAT_HTTP_FALLBACK_PATHS.has(normalizedPath);
}
